import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import type { BookLanguageRow } from '../../Settings/lists/singleTableListSupport';
import { bookLanguageFlagDisplaySrc } from '../../Settings/lists/singleTableListSupport';
import type { BookFormDraft } from './types';

type BookFormStepLanguagesProps = {
  draft: BookFormDraft;
  languages: BookLanguageRow[];
  onToggleLanguage: (langId: string, checked: boolean) => void;
  stepNavigation: React.ReactNode;
};

export default function BookFormStepLanguages({
  draft,
  languages,
  onToggleLanguage,
  stepNavigation,
}: BookFormStepLanguagesProps) {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Номд ашиглах хэлийг асаана. Идэвхтэй хэл бүрт гарчиг, тайлбар, хуудсын орчуулга оруулна.
      </Typography>
      <Stack spacing={1}>
        {languages.map((lang) => {
          const flagSrc = bookLanguageFlagDisplaySrc(lang);
          return (
            <Box
              key={lang.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'nowrap',
                gap: 1.5,
                py: 0.5,
                width: 1,
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 26,
                  flexShrink: 0,
                  borderRadius: 0.5,
                  border: 1,
                  borderColor: 'divider',
                  overflow: 'hidden',
                  bgcolor: 'action.hover',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {flagSrc ? (
                  <Box
                    component="img"
                    src={flagSrc}
                    alt=""
                    sx={{ width: 1, height: 1, objectFit: 'cover', display: 'block' }}
                  />
                ) : null}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'nowrap',
                  gap: 0.75,
                  minWidth: 0,
                  flex: '1 1 0%',
                }}
              >
                <Typography
                  component="span"
                  variant="body2"
                  sx={{
                    flex: '0 1 auto',
                    minWidth: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {lang.name} ({lang.id})
                </Typography>
                <Switch
                  checked={!!draft.language_enabled[lang.id]}
                  onChange={(_, checked) => onToggleLanguage(lang.id, checked)}
                  inputProps={{ 'aria-label': `${lang.name} идэвхжүүлэх` }}
                  sx={{ flexShrink: 0, m: 0 }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
      {stepNavigation}
    </Box>
  );
}
